import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ShortenedDurationWarningComponent } from './shortened-duration-warning.component';

@NgModule({
  declarations: [ShortenedDurationWarningComponent],
  imports: [CommonModule],
  exports: [ShortenedDurationWarningComponent],
})
export class ShortenedDurationWarningModule {}
